module.exports = __webpack_public_path__ + "img/qrcode.4ff0dbb0.png";